<style scoped>

</style>

<template>
  <div>
    <Modal :value="$store.state.editCommentModal.show" width="500" @input="$emit('on-cancel', $event)">
      <div slot="header" style="text-align: center; font-weight: bold">{{ $text.tr('КОММЕНТАРИЙ') }}</div>
      <i-input ref="comment" v-model='commentEdited' size='large' style="margin-top: 20px; margin-bottom: 20px; font-size: 14px" :rows="4" type="textarea" :maxlength="500"></i-input>
      <div slot="footer" style="text-align: center;">
        <Button  :loading="loading" :disabled="loading" size="default" long style="width: 60%; margin-top: 20px; margin-bottom: 10px" @click="update">
          <div v-if="!loading">{{ $text.tr('СОХРАНИТЬ') }}</div>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">

import { Component, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import SlimApi from '@/util/slimapi'
// @ts-ignore
import SlimApis from '@/util/slimapis'
// @ts-ignore
import util from '@/util/util'

@Component
export default class EditCommentModal extends Vue {
  commentEdited = ''
  loading = false

  @Watch('$store.state.editCommentModal.show')
  commentChanged (show: boolean) {
    if (show) {
      this.$nextTick(function () {
        // @ts-ignore
        this.$refs.comment.focus()
      })
    }
    // @ts-ignore
    this.commentEdited = this.$store.state.editCommentModal.comment
  }

  update () {
    const ref = this
    const params = {
      params: {
        // @ts-ignore
        token: ref.$store.state.sys.token,
        // @ts-ignore
        etid: ref.$store.state.sys.tradeExchange.Id,
        // @ts-ignore
        tid: ref.$store.state.editCommentModal.tid,
        comment: this.commentEdited
      }
    }
    SlimApis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get('trade/upd_comment', params)
      .then((response: any) => {
        this.loading = false
        if (response.data !== null) {
          if (!response.data.err) {
            // @ts-ignore
            ref.$store.state.editCommentModal.show = false
            this.$emit('setComment', this.commentEdited)

            // @ts-ignore
            ref.$store.dispatch('updateTrades')
          } else {
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              desc: util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        }
      }).catch((error: any) => {
        this.loading = false
        // error
        console.log(error)
        // @ts-ignore
        ref.$Notice.error({
          // @ts-ignore
          title: ref.$text.tr('Ошибка'),
          desc: util.returnTextForErr(error),
          duration: 10
        })
      })
  }
}
</script>
